import {  Header, Table, Segment } from 'semantic-ui-react';

const NosiaView = (nosia: GetNosiasForAccount) => {
  const renderBillingPeriod = (period: NosaiBillingPeriod, title) => (
    <Segment>
      <Header as="h3">{title}</Header>
      <Table celled>
        <Table.Body>
          <Table.Row>
            <Table.Cell>Billing Period ID</Table.Cell>
            <Table.Cell>{period.billingPeriodId}</Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell>Payment Due Date</Table.Cell>
            <Table.Cell>{new Date(period.paymentDueDate).toLocaleString()}</Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell>Payment Due Amount</Table.Cell>
            <Table.Cell>{`${period.paymentDueAmount.value} ${period.paymentDueAmount.currencyCode}`}</Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell>Contractual Due</Table.Cell>
            <Table.Cell>{`${period.contractualDue.value} ${period.contractualDue.currencyCode}`}</Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell>Payment Allocations</Table.Cell>
            <Table.Cell>
              {period.paymentAllocations.length > 0 ? (
                <Table>
                  <Table.Header>
                    <Table.Row>
                      <Table.HeaderCell>Transaction ID</Table.HeaderCell>
                      <Table.HeaderCell>Allocated Amount</Table.HeaderCell>
                      <Table.HeaderCell>Transaction Date</Table.HeaderCell>
                    </Table.Row>
                  </Table.Header>
                  <Table.Body>
                    {period.paymentAllocations.map((allocation) => (
                      <Table.Row key={allocation.transactionId}>
                        <Table.Cell>{allocation.transactionId}</Table.Cell>
                        <Table.Cell>{`${allocation.allocatedAmount.value} ${allocation.allocatedAmount.currencyCode}`}</Table.Cell>
                        <Table.Cell>{new Date(allocation.transactionDate).toLocaleString()}</Table.Cell>
                      </Table.Row>
                    ))}
                  </Table.Body>
                </Table>
              ) : (
                'No allocations'
              )}
            </Table.Cell>
          </Table.Row>
          <Table.Row>
            <Table.Cell>Credits</Table.Cell>
            <Table.Cell>
              {period.credits.length > 0 ? (
                <Table>
                  <Table.Header>
                    <Table.Row>
                      <Table.HeaderCell>Credit Amount</Table.HeaderCell>
                      <Table.HeaderCell>Credit Date</Table.HeaderCell>
                    </Table.Row>
                  </Table.Header>
                  <Table.Body>
                    {period.credits.map((credit) => (
                      <Table.Row>
                        <Table.Cell>{`${credit.amount.value} ${credit.amount.currencyCode}`}</Table.Cell>
                        <Table.Cell>{new Date(credit.timestamp).toLocaleString()}</Table.Cell>
                      </Table.Row>
                    ))}
                  </Table.Body>
                </Table>
              ) : (
                'No credits'
              )}
            </Table.Cell>
          </Table.Row>
        </Table.Body>
      </Table>
    </Segment>
  );

  return (
    <>
      <Header as="h2">Nosia Details</Header>

      <Segment key={nosia.firstBillingPeriod.billingPeriodId}>
        {renderBillingPeriod(nosia.firstBillingPeriod, 'First Billing Period')}
        {renderBillingPeriod(nosia.lastBillingPeriod, 'Last Billing Period')}
        <Segment>
          <Header as="h3">Shortfall Amount</Header>
          <Table celled>
            <Table.Body>
              <Table.Row>
                <Table.Cell>Amount</Table.Cell>
                <Table.Cell>{`${nosia.shortfallAmount.value} ${nosia.shortfallAmount.currencyCode}`}</Table.Cell>
              </Table.Row>
            </Table.Body>
          </Table>
        </Segment>
      </Segment>
    </>
  );
};

export default NosiaView;
